export default __webpack_public_path__ + "static/media/O-072.a7004c24.png";